import React,{useEffect} from "react";
import {Link } from "react-router-dom";
import Carousel from 'react-bootstrap/Carousel';
import check from "../images/check.png";
const Java_Development = () =>
{

return(
<>
<div className="web-page">
  <section className="">
    <div className="container px-0">
      <div className="row py-5 align-items-stretch xs-column-reverse">
        <div className="col-md-6  align-self-center">
          <div className="techUse-title ">
            <h1><span className="sub-color">Java </span>Development</h1>
          </div>
          <p>We at BFC Softtech take great pride in our systematic approach to Java software development. Continue reading as we break down our process into distinct phases.</p>
          <Link to="/contact" className="btn btn-s">
          Let's Talk
          </Link>
        </div>
        <div className="col-md-6">
          <img src="../assets/img/solutions/java.png" alt="" srcset="" className="img-fluid" />
        </div>
      </div>
    </div>
  </section>
  <section className="bg-light-blue py-5">
    <div className="container px-0">
      <div className="row">
        <div className="col-md-12">
          <div className="techUse-title text-center ">
            <h1>Our <span className="sub-color"> Java </span> Development Process </h1>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 text-center">
        <img src="../assets/img/solutions/IT Process.png" className="img-fluid" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section className="py-lg-5">
    <div className="container px-0">
      <div className="row justify-content-center pt-4">
        <div className="col-md-12 text-center">
          <div className="techUse-title text-center">
            <h1>Why you should opt for <span className="sub-color"> Java Development </span> </h1>
          </div>
          <p className="short-desc">By opting for Java Development, businesses can take their operations online and augment their growth. Professional Java developers can design robust, enterprise-level apps that match your business’s specific demands. </p>
        </div>
      </div>
      <div className="row why-go pb-4">
        <div className="col-md-4 ml-3 ba">
          <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Developing E-commerce Platforms </h4>
            <p>
            With more and more customers shopping online, businesses that do not have an online store are at a significant disadvantage. By leveraging professional Java developers’ technical expertise, you can develop e-commerce platforms capable of selling your products online. 
            </p>
          </div>
          </span>
        </div>
        {/* <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Automating Business Processes</h4>
            <p>
            Java development can help you automate your operations by developing applications that streamline business processes such as inventory management, order processing, and customer service. 
            </p>
          </div>
          </span>
        </div> */}
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Developing Web and Mobile Applications</h4>
            <p>
            Java development can help businesses create web and mobile applications compatible with various platforms, allowing them to reach a broader audience and improve customer engagement. 
            </p>
          </div>
          </span>
        </div>
        <div className="col-md-4 ml-3 ba">
        <span>
          <div className="hover-icon">
          <img src={check} alt="" srcset="" className="img-fluid" />
            <h4 className="color-bluec pt-3">Enhancing Security and Scalability </h4>
            <p>
            A competent development team will have the know-how needed to leverage Java’s built-in security features, such as bytecode verification and sandboxing, helping prevent unauthorized access to sensitive client data and protecting your business against malware attacks. 
            </p>
          </div>
          </span>
        </div>
      
      </div>
    </div>
  </section>
  <section>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="techUse-title text-center">
            <h1>  Why Choose <span className="sub-color">BFC Softtech</span> as your <span className="sub-color"> Java Development </span> Company? </h1>
          </div>
        </div>
        <div className="col-md-8 text-center ">
          <p className="short-desc">BFC Softtech has helped countless organisations grow over the years by providing solid, enterprise-level Java applications. Here are some of the reasons why we should be your Java Development Partner. </p>
        </div>
      </div>
      <div className="row py-5">
        <section className="web-banner mb-4">
          <Carousel>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/dev.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title pt-3">
                            <h4 className="color-bluec ">Expertise in Java Development </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">Our team has proven competence in Java programming and has created Java-based solutions for a variety of sectors.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/expert.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title ">
                            <h4 className="color-bluec ">Customized Solutions </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">We offer bespoke Java development solutions that are suited to your company's  specific requirements.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/new/quality.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title ">
                            <h4 className="color-bluec ">Quality Assurance </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">To ensure that the solutions we design are of the greatest quality and meet industry standards, we subject them to a thorough testing process.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item interval={2000}>
              <div className="banner-content">
                <div className="container px-0">
                  <div className="row">
                    <div className="col-lg-5">
                      <div className="banner-img">
                        <div className="">                       
                          <img src="../assets/img/solutions/new/support.jpg" className="img-fluid" alt="" />                           
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-7 d-flex align-items-stretch ">
                      <div className="align-self-center">
                        <div className="banner-content">
                          <div className="banner-title ">
                            <h4 className="color-bluec ">Excellent Customer Support </h4>
                          </div>
                          <div className="banner-disc">
                            <p className="">We provide 24/7 customer support, ensuring that your business never goes offline. </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          </Carousel>
        </section>
      </div>
    </div>
  </section>
 
</div>
</>
)
}
export default Java_Development